import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { AuthGuardService } from './services/auth-guard.service';
import { CENTRAL_PLATFORM, STUDY_AND_ROLE_ROUTE } from './constant/constant';


const routes: Routes = [
  {
    path: '',
    component: LoginComponent
  },
  {
    path: 'forgotPassword',
    loadChildren: () =>
      import('src/app/components/forgot-password/forgot-password-routing.module')
        .then(m => m.ForgotPasswordRoutingModule)
  },
  {
    path: CENTRAL_PLATFORM,
    canActivate: [AuthGuardService],
    canMatch: [AuthGuardService],
    loadChildren: () =>
      import('src/app/components/layout/layout.module')
        .then(m => m.LayoutModule)
  },
  {
    path: STUDY_AND_ROLE_ROUTE,
    canActivate: [AuthGuardService],
    component: LoginComponent
  },
  {
    path: '**',
    redirectTo: ''
  }
];
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}



